import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  filterPanelComplexitiesLabel: {
    id: 'filterPanelComplexitiesLabel',
    defaultMessage: 'Complexity',
  },
  filterPanelCategoriesLabel: {
    id: 'filterPanelCategoriesLabel',
    defaultMessage: 'Category',
  },
  beginner: {
    id: 'beginnerComplexity',
    defaultMessage: 'Beginner',
    description: 'Tag describing complexity',
  },
  intermediate: {
    id: 'intermediateComplexity',
    defaultMessage: 'Intermediate',
    description: 'Tag describing complexity',
  },
  advanced: {
    id: 'advancedComplexity',
    defaultMessage: 'Advanced',
    description: 'Tag describing complexity',
  },
  isInPresets: {
    id: 'filterPanel.isInPresets',
    defaultMessage: 'In Presets',
  },
  notInPresets: {
    id: 'filterPanel.notInPresets',
    defaultMessage: 'Not in Presets',
  },
  allowedInStrictTransformations: {
    id: 'custom-card.allowed-strict',
    defaultMessage: 'Allowed for strict transformations',
    description: 'A tag (chip) on a custom transformation card',
  },
  notAllowedInStrictTransformations: {
    id: 'custom-card.not-allowed-strict',
    defaultMessage: 'Not allowed for strict transformations',
    description: 'A tag (chip) on a custom transformation card',
  },
  strictTransformations: {
    id: 'strictTransformations',
    defaultMessage: 'Strict Transformations:',
  },
  strictTransformationsLearnMoreButton: {
    id: 'strictTransformationsLearnMore',
    defaultMessage: 'Learn More',
    description: 'A button placed in strict transformations dropdown, navigates to Cloudinary docs',
  },
  imageStrictTransformations: {
    id: 'imageStrictTransformations',
    defaultMessage: 'Image Strict Transformations:',
  },
  videoStrictTransformations: {
    id: 'videoStrictTransformations',
    defaultMessage: 'Video Strict Transformations:',
  },
  strictTransformationsModalHeader: {
    id: 'strictTransformationsModalHeader',
    defaultMessage: 'Are you sure?',
  },
  strictTransformationsModalCancel: {
    id: 'strictTransformationsModalCancel',
    defaultMessage: 'Cancel',
  },
  strictTransformationsEnableConfirm: {
    id: 'enableStrictTransformationsConfirm',
    defaultMessage: 'Enable Strict Transformations',
  },
  strictTransformationsDisableConfirm: {
    id: 'strictTransformationsDisableConfirm',
    defaultMessage: 'Disable Strict Transformations',
  },
  strictTransformationsModalEnableContent: {
    id: 'strictTransformationsModalEnableContent',
    defaultMessage: `With Strict Transformations enabled, the dynamic creation of new derived assets is blocked by default. 
      New derived images can be created via the API, and can allowed using several other methods.`,
  },
  strictTransformationsModalDisableContent: {
    id: 'strictTransformationsModalDisabledContent',
    defaultMessage: 'TODO',
  },
  enabled: {
    id: 'enabled',
    defaultMessage: 'Enabled',
  },
  disabled: {
    id: 'disabled',
    defaultMessage: 'Disabled',
  },
  inPresets: {
    id: 'custom-card.in-presets',
    defaultMessage: 'In presets',
    description: 'A tag (chip) on a custom transformation card',
  },
  noTransformationsMatch: {
    id: 'noTransformationsMatch',
    defaultMessage: 'No transformations match your search',
    description: 'Title of failed search page',
  },
  refineTransformationsSearch: {
    id: 'refineTransformationsSearch',
    defaultMessage: 'Refine your search or <action>create</action> your own transformation',
    description: 'Subtitle of failed search page, contains CTA (action)',
  },
  modalUseThisTemplate: {
    id: 'modal.useThisTemplate',
    defaultMessage: 'Use this template',
    description: 'Label of button that applies cookbook as template',
  },
  modalUseThisTemplateMessage: {
    id: 'modal.useThisTemplateMessage',
    defaultMessage:
      'To use the image you see in the preview, it must be added to your Media Library. Would you like to add the asset to your Media Library?',
    description: 'Message of modal which appears when clicking "Use this template" button',
  },
  modalUseThisTemplateAddAssetsToMediaLibrary: {
    id: 'modal.useThisTemplateMessageAddAssetsToMediaLibrary',
    defaultMessage: 'Add asset to Media Library',
    description: 'Text shown on a button to add assets, which are used by template, to media library',
  },
  modalClose: {
    id: 'cookbook-common.modal.close',
    defaultMessage: 'Close',
    description: 'Label of button that closes the dialog',
  },
  viewSample: {
    id: 'viewSample',
    defaultMessage: 'View sample',
    description: 'Tooltip shown above transformation thumbnail. Clicking the thumbnail will navigate to new tab with raw asset (res.cloudinary.com/...)',
  },
  menuIconTooltip: {
    id: 'menu.icon',
    defaultMessage: 'Open menu',
    description: 'Shows as a tooltip for menu icon',
  },
  menuItemEdit: {
    id: 'menu.edit',
    defaultMessage: 'Edit transformation',
    description: 'Shows in menu on mobile, and as a tooltip text for icon when on desktop',
  },
  menuItemCopy: {
    id: 'menu.copy',
    defaultMessage: 'Duplicate transformation',
    description: 'Shows in menu on mobile, and as a tooltip text for icon when on desktop',
  },
  menuIconDelete: {
    id: 'menu.delete',
    defaultMessage: 'Delete',
    description: 'Shows in menu, triggers deletion of custom transformation',
  },
  menuPresetsSettingsTitle: {
    id: 'menu.presets-settings-title',
    defaultMessage: 'Presets',
    description: 'Shows in menu, as a title.',
  },
  menuShowInImagePresets: {
    id: 'menu.show-in-image-presets',
    defaultMessage: 'Show in image presets',
    description: 'Shows in menu, as a toggle. When enabled shows transformation in image presets.',
  },
  menuShowInVideoPresets: {
    id: 'menu.show-in-video-presets',
    defaultMessage: 'Show in video presets',
    description: 'Shows in menu, as a toggle. When enabled shows transformation in video presets.',
  },
  menuStrictTransformations: {
    id: 'menu.allowed-for-strict-transformations',
    defaultMessage: 'Allowed for strict transformations',
    description: 'Shows in menu, as a toggle. When enabled allows use in strict transformations.',
  },
  lastUsed: {
    id: 'last-used',
    defaultMessage: `{wasEverUsed, select,
      yes {Last used on {lastUse, date, long}, {lastUse, time, short}}
      other {Never used}
    }`,
    description: 'Describes how many times was the transformation used, and when was the last time',
  },
  addNewTransformation: {
    id: 'addNewTransformation',
    defaultMessage: 'Add New',
    description: 'Button for creating transformations, it is CTA and have limited space',
  },
  addNewTransformationLegacy: {
    id: 'addNewTransformationLegacy',
    defaultMessage: 'Add New with Legacy Editor',
    description: 'Button for creating legacy transformations',
  },
  sortTransformations: {
    id: 'sortTransformations',
    defaultMessage: 'Sort A-Z',
    description: 'Button for sorting transformations',
  },
  visiblePageItemsInfo: {
    id: 'visiblePageItemsInfo',
    defaultMessage: '{fromIndex, number}-{toIndex, number} of {listSize, number}',
    description: 'Information about the visible indexes and total number of pages',
  },
  pageSwitcher: {
    id: 'pageSwitcher',
    defaultMessage: 'Page <input></input> of {totalPages, number}',
    description: 'Total and current pages with input to change it',
  },
  duplicateTransformation: {
    id: 'duplicateTransformation',
    defaultMessage: 'Duplicate a Named Transformation',
    description: 'Duplicate a transformation modal title',
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
    description: 'Button for canceling a duplicate action and closing the modal',
  },
  saveTransformation: {
    id: 'saveTransformation',
    defaultMessage: 'Save Transformation',
    description: 'Button for saving a duplicated transformation',
  },
  transformationName: {
    id: 'transformationName',
    defaultMessage: 'Transformation Name',
    description: 'Label of the text-field in duplicate transformation modal',
  },
  enterName: {
    id: 'enterName',
    defaultMessage: 'Enter a valid transformation name',
    description: 'Validation message in duplicate modal when no transformation name provided',
  },
  nameAlreadyExists: {
    id: 'nameAlreadyExists',
    defaultMessage: 'Name already exists',
    description: 'Validation message in duplicate modal when transformation with provided name already exists',
  },
  tipsSectionTitle: {
    id: 'tipsSectionTitle',
    defaultMessage: 'Tips for naming a transformation:',
    description: 'Title for tips section in duplicate transformation modal',
  },
  relevantTransformationNameTip: {
    id: 'relevantTransformationNameTip',
    defaultMessage: 'Use a name that is relevant to the transformation',
    description: 'A tip inside the duplicate transformation modal',
  },
  notAllowedCharactersTip: {
    id: 'notAllowedCharactersTip',
    defaultMessage: "The name must not include any spaces or the following symbols: /:*'<>'|",
    description: 'A tip inside the duplicate transformation modal',
  },
  namedTransformationUsageTip: {
    id: 'namedTransformationUsageTip',
    defaultMessage: "After saving the transformation, write t_'<name>' when using in your code",
    description: 'A tip inside the duplicate transformation modal',
  },
});
